

const Video = ({ embedId }) => (
    <div className="video-responsive">
        <div className="video-responsive-wrapper">
            <iframe
                width="853"
                height="480"
                src={`https://www.youtube.com/embed/${embedId}`}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                title="Embedded youtube"
                poster={`https://via.placeholder.com/624x380.png`}
            />
        </div>
    </div>
);

export default Video;